export * from './delete-rechnung.component';
export * from './delete-rechnung.component.module';